export default "__VITE_ASSET__qCdme17v__"